module.exports = __webpack_public_path__ + "img/btn_menu_promotion.73b3754e.svg";